import { Config, UserGroups } from '@constants'
import { isClient, isTutor } from './user'

const addIdsToParticipants = (participants) => {
  const keys = Object.keys(participants)
  return keys.map((key) => ({ id: key, ...participants[key] }))
}

const getPersonFromParticipants = (self, participants) => {
  const callerIsTutor = isTutor(self.type)
  const values = addIdsToParticipants(participants)

  const filteredParticipants = values.filter((v) =>
    callerIsTutor ? isClient(v.type) : isTutor(v.type)
  )
  return filteredParticipants[0]
}

const getAppointmentParticipants = (participants) =>
  Object.keys(participants).filter((id) => id !== Config.GP_BOT)

const canAddParticipant = (self, userGroup, currentParticipants) => {
  if (!userGroup?.participants) return false

  if (
    userGroup.participants.find((p) => p.user?._id === self._id).role !==
    UserGroups.GROUP_MEMBER_ROLE.OWNER
  )
    return false

  const acceptedGroupParticipants = userGroup.participants.filter((p) => p.user)

  return acceptedGroupParticipants.some(
    (p) => p.user._id !== self._id && !currentParticipants[p.user._id]
  )
}

const getOptionsForAddingParticipants = (
  self,
  userGroup,
  currentParticipants
) => {
  if (!userGroup?.participants) return []

  return [
    ...addIdsToParticipants(currentParticipants)
      .filter((p) => p.id !== Config.GP_BOT && p.type !== 'tutor')
      .map((p) => {
        p.isFixed = true
        return p
      }),
    ...userGroup.participants
      .filter(
        (p) =>
          p.user && p.user._id !== self._id && !currentParticipants[p.user._id]
      )
      .map((p) => {
        const copy = { ...p }
        const user = copy.user
        delete copy.user
        return { ...copy, ...user, id: user._id }
      })
  ]
}

const getParticipantsFromSameGroup = (self, userGroup, participants) => {
  if (!userGroup?.participants) return []
  return addIdsToParticipants(participants).filter(
    (p) =>
      p.id !== self._id &&
      userGroup.participants.find(({ user }) => user?._id === p.id)
  )
}

export default {
  getPersonFromParticipants,
  getAppointmentParticipants,
  canAddParticipant,
  getOptionsForAddingParticipants,
  getParticipantsFromSameGroup
}
